<template>
  <div>
    <TitlePage :title="$t('edit')+' '+$t('customer')"></TitlePage>

    <v-layout wrap>

      <v-flex md12 class="d-flex">
        <v-chip color="primary" label small text-color="white">{{$t('genericInfo')}}</v-chip>
      </v-flex>

      <v-flex md4 class="pl-4 pr-4">
        <v-text-field :label="$t('name')" v-model="item.name" :rules="validation.textRules" :error-messages="errors.name"></v-text-field>
      </v-flex>

      <v-flex md4 class="pl-4 pr-4">
        <v-text-field :label="$t('surname')" v-model="item.surname" :rules="validation.textRules" :error-messages="errors.surname"></v-text-field>
      </v-flex>

      <v-flex md2 class="pl-4 pr-4">
        <v-switch v-model="item.active" inset :label="$t('status')" dense hide-details></v-switch>
      </v-flex>

      <v-flex md4 class="pl-4 pr-4">
        <v-text-field :label="$t('email')" v-model="item.email" :disabled="item.email_verified" :prepend-icon="(item.email_verified)?'mdi-check-decagram':''" :error-messages="errors.email" :rules="validation.email"></v-text-field>
      </v-flex>

      <v-flex md2 class="pl-4 pr-4">
        <v-switch v-model="item.email_verified" inset :label="$t('email_verified')" dense hide-details></v-switch>
      </v-flex>

      <v-flex md4 class="pl-4 pr-4">
        <v-text-field :label="$t('phone')" v-model="item.phone" :disabled="item.phone_verified" :prepend-icon="(item.phone_verified)?'mdi-check-decagram':''"></v-text-field>
      </v-flex>

      <v-flex md2 class="pl-4 pr-4">
        <v-switch v-model="item.phone_verified" inset :label="$t('phone_verified')" dense hide-details></v-switch>
      </v-flex>

      <v-flex md4 class="pl-4 pr-4">
        <v-text-field :label="$t('password')" v-model="item.password"
                      :append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'" :type="showPassword ? 'text' : 'password'"
                      @click:append="showPassword = !showPassword" :error-messages="errors.password"
        ></v-text-field>
      </v-flex>

      <v-flex md12 class="pl-4 pr-4">
        <vuetify-google-autocomplete id="map" :placeholder="$t('addressComplete')" v-on:placechanged="setAddressData" v-model="item.address_complete">
        </vuetify-google-autocomplete>
      </v-flex>

      <v-flex md12 class="d-flex pt-5">
        <v-chip color="primary" label small text-color="white">{{$t('financialInfo')}}</v-chip>
      </v-flex>

      <v-flex md3 class="pl-4 pr-4">
        <v-text-field :label="$t('company')" v-model="item.financial_info.company"></v-text-field>
      </v-flex>
      <v-flex md3 class="pl-4 pr-4">
        <v-text-field :label="$t('address')" v-model="item.financial_info.address"></v-text-field>
      </v-flex>
      <v-flex md2 class="pl-4 pr-4">
        <v-text-field :label="$t('city')" v-model="item.financial_info.city"></v-text-field>
      </v-flex>
      <v-flex md2 class="pl-4 pr-4">
        <v-text-field :label="$t('province')" v-model="item.financial_info.province"></v-text-field>
      </v-flex>
      <v-flex md1 class="pl-4 pr-4">
        <v-text-field :label="$t('postal_code')" v-model="item.financial_info.postal_code"></v-text-field>
      </v-flex>
      <v-flex md1 class="pl-4 pr-4">
        <v-text-field :label="$t('country')" v-model="item.financial_info.country"></v-text-field>
      </v-flex>
      <v-flex md3 class="pl-4 pr-4">
        <v-text-field :label="$t('vat_code')" v-model="item.financial_info.vat_code"></v-text-field>
      </v-flex>
      <v-flex md3 class="pl-4 pr-4">
        <v-text-field :label="$t('fiscal_code')" v-model="item.financial_info.fiscal_code"></v-text-field>
      </v-flex>
      <v-flex md3 class="pl-4 pr-4">
        <v-text-field :label="$t('sdi_code')" v-model="item.financial_info.sdi_code"></v-text-field>
      </v-flex>
      <v-flex md3 class="pl-4 pr-4">
        <v-text-field :label="$t('pec_address')" v-model="item.financial_info.pec_address"></v-text-field>
      </v-flex>

      <v-flex v-if="getUser.super_admin" md12 class="d-flex pt-5">
        <v-chip color="primary" label small text-color="white">Skills</v-chip>
      </v-flex>

      <v-flex v-if="getUser.super_admin" md12 class="pl-4 pr-4">
        <v-sheet outlined class="customer-skills-editor pa-4">
          <div class="d-flex justify-space-between align-center flex-wrap mb-4">
            <div>
              <h3 class="customer-skills-title mb-1">Skill utente</h3>
              <div class="text-caption text--secondary">
                Gestione admin: puoi salvare modifiche anche prima della scadenza dei 30 giorni.
              </div>
            </div>
            <v-btn small outlined color="primary" :loading="loadingSkills" @click="loadSkills">
              <v-icon left small>mdi-refresh</v-icon>
              Aggiorna dati
            </v-btn>
          </div>

          <v-alert v-if="!sportConfigs.length && !loadingSkills" outlined dense type="info" class="mb-0">
            Nessuna configurazione disponibile per le skill.
          </v-alert>

          <div v-else>
            <v-sheet rounded class="customer-skills-sport-bar mb-5 pa-2">
              <v-slide-group v-model="selectedSkillSport" center-active show-arrows>
                <v-slide-item
                    v-for="config in sortedSportConfigs"
                    :key="config.sport_master"
                    :value="config.sport_master"
                >
                  <v-btn
                      depressed
                      class="customer-skills-sport-pill mx-1"
                      :class="{ 'customer-skills-sport-pill--active': selectedSkillSport === config.sport_master }"
                      @click="selectedSkillSport = config.sport_master"
                  >
                    <v-icon left small>{{ getSportIcon(config.sport_master) }}</v-icon>
                    {{ getSportLabel(config.sport_master) }}
                    <span class="ml-1">({{ getSkillDraft(config.sport_master).overall || '-' }})</span>
                  </v-btn>
                </v-slide-item>
              </v-slide-group>
            </v-sheet>

            <v-row v-if="activeSkillConfig">
              <v-col cols="12" md="8">
                <div v-if="roleItems(activeSkillConfig).length" class="mb-5">
                  <div class="d-flex align-center justify-space-between mb-2">
                    <h5 class="customer-skills-section-title mb-0">Ruolo preferito</h5>
                    <span class="text-caption text--secondary">Seleziona il ruolo principale</span>
                  </div>

                  <v-row dense>
                    <v-col
                        v-for="role in activeSkillRoles"
                        :key="role.value"
                        cols="12"
                        sm="6"
                        class="pb-2"
                    >
                      <v-card
                          outlined
                          class="customer-skills-role-card pa-3"
                          :class="{ 'customer-skills-role-card--active': activeSkillDraft.role_key === role.value }"
                          @click="activeSkillDraft.role_key = role.value"
                      >
                        <div class="font-weight-bold">{{ role.text }}</div>
                        <div class="text-caption">{{ role.description || 'Ruolo in campo' }}</div>
                      </v-card>
                    </v-col>
                  </v-row>
                </div>

                <div>
                  <h5 class="customer-skills-section-title mb-2">Valutazione skill</h5>
                  <v-row dense>
                    <v-col
                        v-for="skill in activeSkills(activeSkillConfig)"
                        :key="`${activeSkillConfig.sport_master}-${skill.key}`"
                        cols="12"
                        sm="6"
                        class="pb-3"
                    >
                      <v-card outlined class="customer-skills-skill-card pa-3">
                        <div class="d-flex align-start justify-space-between">
                          <div class="d-flex align-start flex-grow-1">
                            <div class="customer-skills-skill-badge mr-3">
                              {{ getSkillShort(skill) }}
                            </div>
                            <div class="flex-grow-1">
                              <div class="font-weight-medium">{{ skill.name || skill.label || skill.key }}</div>
                              <div class="text-caption text--secondary">
                                Min {{ skill.min || 1 }} - Max {{ skill.max || 10 }}
                              </div>
                              <div v-if="skill.description" class="text-caption text--secondary customer-skills-description">
                                {{ skill.description }}
                              </div>
                            </div>
                          </div>

                          <div class="customer-skills-value d-flex align-center">
                            <v-btn icon x-small @click.stop="adjustSkill(activeSkillConfig, skill, -1)">
                              <v-icon small>mdi-minus</v-icon>
                            </v-btn>
                            <div class="customer-skills-value-number">{{ getSkillValue(activeSkillConfig, skill) }}</div>
                            <v-btn icon x-small @click.stop="adjustSkill(activeSkillConfig, skill, 1)">
                              <v-icon small>mdi-plus</v-icon>
                            </v-btn>
                          </div>
                        </div>

                        <v-slider
                            v-model.number="activeSkillDraft.skills[skill.key]"
                            :min="skill.min || 1"
                            :max="skill.max || 10"
                            :step="skill.step || 1"
                            hide-details
                            dense
                            color="secondary"
                            track-color="grey lighten-1"
                            class="mt-2"
                            @change="recomputeSkillOverall(activeSkillConfig)"
                        />
                      </v-card>
                    </v-col>
                  </v-row>
                </div>
              </v-col>

              <v-col cols="12" md="4">
                <v-card outlined class="customer-skills-overall-card pa-4 mb-4" :class="`customer-skills-overall-card--${overallLevel.tier}`">
                  <div class="text-center">
                    <div class="customer-skills-overall-caption">Overall</div>
                    <div class="customer-skills-overall-value">{{ activeSkillDraft.overall || '-' }}</div>
                    <div class="customer-skills-overall-label">{{ overallLevel.label }}</div>
                  </div>

                  <v-divider class="my-4"></v-divider>

                  <div class="d-flex align-center mb-2">
                    <v-icon small class="mr-2">mdi-calendar-clock</v-icon>
                    <span class="text-caption text--secondary">Ultimo aggiornamento</span>
                  </div>
                  <div class="font-weight-medium mb-3">
                    {{ formatDateTime(activeSkillDraft.last_skills_updated_at) }}
                  </div>

                  <v-alert dense outlined type="info" class="mb-4">
                    Il salvataggio admin bypassa il limite dei 30 giorni dell'app utente.
                  </v-alert>

                  <v-btn
                      block
                      color="primary"
                      :loading="savingSkill"
                      @click="saveSkill(activeSkillConfig)"
                  >
                    Salva skill ora
                    <v-icon right small>mdi-content-save</v-icon>
                  </v-btn>
                </v-card>

                <v-card outlined class="customer-skills-radar-card pa-4">
                  <div class="text-subtitle-2 font-weight-medium mb-3">Panoramica stats</div>
                  <div class="customer-skills-radar-wrapper">
                    <svg viewBox="0 0 200 200" class="customer-skills-radar-svg">
                      <polygon
                          v-for="level in [0.33, 0.66, 1]"
                          :key="'grid-' + level"
                          :points="getRadarGridPoints(level)"
                          class="customer-skills-radar-grid"
                      />
                      <polygon v-if="radarPolygonPoints" :points="radarPolygonPoints" class="customer-skills-radar-data" />
                      <circle
                          v-for="axis in radarAxes"
                          :key="axis.skill.key"
                          :cx="axis.x"
                          :cy="axis.y"
                          r="3"
                          class="customer-skills-radar-dot"
                      />
                      <text
                          v-for="axis in radarAxes"
                          :key="'text-' + axis.skill.key"
                          :x="axis.labelX"
                          :y="axis.labelY"
                          class="customer-skills-radar-text"
                          text-anchor="middle"
                          dominant-baseline="middle"
                      >
                        {{ getSkillShort(axis.skill) }}
                      </text>
                    </svg>
                  </div>
                </v-card>
              </v-col>
            </v-row>
          </div>
        </v-sheet>
      </v-flex>

      <v-flex md12 class="pt-10 d-flex">
        <v-divider class="marg-title"></v-divider>
      </v-flex>
      <v-flex md12 class="pt-5 d-flex buttons-group-mobile">
        <v-btn elevation="2" color="" class="mr-auto" @click="$router.go(-1)">
          <v-icon left>mdi-keyboard-backspace</v-icon>
          {{ $t('back') }}
        </v-btn>
        <v-btn elevation="2" color="primary" class="ml-auto" @click="update" type="submit">
          {{ $t('save') }}
          <v-icon right>mdi-content-save</v-icon>
        </v-btn>
      </v-flex>

    </v-layout>
  </div>
</template>

<script>
import TitlePage from "@/components/utils/TitlePage";
import {mapGetters, mapMutations, mapActions} from 'vuex';

export default {
  name: "EditCustomer",
  components: {TitlePage},
  computed:{
    ...mapGetters({
      'getUser':'user/getUser'
    }),
    sortedSportConfigs(){
      const configs = [...this.sportConfigs];
      const withOverall = [];
      const withoutOverall = [];

      configs.forEach((config) => {
        const draft = this.getSkillDraft(config.sport_master);
        const overall = Number(draft.overall);
        if (draft.overall !== null && draft.overall !== undefined && !isNaN(overall)) {
          withOverall.push({ config, overall });
        } else {
          withoutOverall.push(config);
        }
      });

      const sortByPriority = (a, b) => {
        const pA = this.sportPriority[a.sport_master] !== undefined ? this.sportPriority[a.sport_master] : 999;
        const pB = this.sportPriority[b.sport_master] !== undefined ? this.sportPriority[b.sport_master] : 999;
        if (pA !== pB) return pA - pB;
        return a.sport_master.localeCompare(b.sport_master);
      };

      return [
        ...withOverall.sort((a, b) => b.overall - a.overall).map(item => item.config),
        ...withoutOverall.sort(sortByPriority),
      ];
    },
    activeSkillConfig(){
      if (!this.selectedSkillSport && this.sortedSportConfigs.length) {
        return this.sortedSportConfigs[0];
      }
      return this.sportConfigs.find(config => config.sport_master === this.selectedSkillSport) || null;
    },
    activeSkillDraft(){
      if (!this.activeSkillConfig) {
        return { role_key: null, skills: {}, overall: null, last_skills_updated_at: null };
      }
      return this.getSkillDraft(this.activeSkillConfig.sport_master);
    },
    activeSkillRoles(){
      if (!this.activeSkillConfig || !Array.isArray(this.activeSkillConfig.roles)) return [];
      return this.activeSkillConfig.roles
          .filter(role => role.active !== false)
          .map(role => ({
            text: role.name || role.label || role.key,
            value: role.key,
            description: role.description || null,
          }));
    },
    radarSkills(){
      if (!this.activeSkillConfig) return [];
      return this.activeSkills(this.activeSkillConfig).slice(0, 6);
    },
    radarAxes(){
      const center = 100;
      const baseRadius = 70;
      const skills = this.radarSkills;
      const count = skills.length;
      if (!count) return [];

      return skills.map((skill, index) => {
        const angle = (Math.PI * 2 / count) * index - Math.PI / 2;
        const max = skill.max || 10;
        const raw = Number(this.activeSkillDraft.skills[skill.key] || 0);
        const clamped = Math.max(0, Math.min(max, raw));
        const normalized = clamped / max;
        const dataRadius = baseRadius * (0.2 + 0.8 * normalized);
        const labelRadius = baseRadius + 13;

        return {
          skill,
          x: center + dataRadius * Math.cos(angle),
          y: center + dataRadius * Math.sin(angle),
          labelX: center + labelRadius * Math.cos(angle),
          labelY: center + labelRadius * Math.sin(angle),
        };
      });
    },
    radarPolygonPoints(){
      return this.radarAxes.map(axis => `${axis.x},${axis.y}`).join(' ');
    },
    overallLevel(){
      const raw = this.activeSkillDraft.overall;
      const value = Number(raw);
      if (raw === null || raw === undefined || isNaN(value)) return { tier: 'none', label: 'Non valutato' };
      if (value <= 3.5) return { tier: 'low', label: 'Livello basso' };
      if (value <= 7) return { tier: 'mid', label: 'Livello medio' };
      return { tier: 'high', label: 'Livello alto' };
    },
  },
  data() {
    return {
      showPassword: false,
      loadingSkills: false,
      savingSkill: false,
      selectedSkillSport: null,
      sportConfigs: [],
      customerSkills: [],
      skillDrafts: {},
      sportPriority: {
        calcio: 1,
        padel: 2,
        tennis: 3,
        basket: 4,
      },
      item: {
        name: '',
        surname: '',
        email: '',
        password: '',
        phone: '',
        address_complete: "",
        position:{
          type: "",
          coordinates:[]
        },
        financial_info: {
          company: "",
          address: "",
          city: "",
          province: "",
          postal_code: "",
          country: "",
          vat_code: "",
          fiscal_code: "",
          sdi_code: "",
          pec_address: ""
        },
        active: false,
        email_verified: false,
        phone_verified: false,
      },
      check: true,
      errors:{
        name: '',
        surname: '',
        email: '',
        password: ''
      },
      validation: {
        textRules: [
          v => !!v || this.$t('fillMandatory'),
        ],
        email: [
          v => {
            const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
            return pattern.test(v) || this.$t('emailNotValid')
          }
        ],
      }
    };
  },
  async created(){
    this.setLoading(true);
    var fetchItem = await this.editItem(this.$route.params)

    this.item.name = fetchItem.result.name;
    this.item.surname = fetchItem.result.surname;
    this.item.email = fetchItem.result.email;
    this.item.phone = fetchItem.result.phone;
    this.item.address_complete = fetchItem.result.address_complete;
    this.item.position = fetchItem.result.position;
    this.item.financial_info = fetchItem.result.financial_info;
    this.item.active = fetchItem.result.active;
    this.item.email_verified = (fetchItem.result.email_verified)?fetchItem.result.email_verified:false;
    this.item.phone_verified = (fetchItem.result.phone_verified)?fetchItem.result.phone_verified:false;

    if (this.getUser.super_admin) {
      await this.loadSkills();
    }

    this.setLoading(false);
  },
  methods: {
    ...mapMutations({
      'setLoading': 'settings/setLoading',
      'setNotification': 'settings/setNotification',
    }),
    ...mapActions({
      'editItem':'customers/edit',
      'updateItem':'customers/update',
      'fetchSportConfigs':'sportMasterConfig/index',
      'fetchCustomerSkills':'customerSkills/getByCustomer',
      'upsertCustomerSkill':'customerSkills/upsert',
    }),
    async loadSkills(){
      this.loadingSkills = true;
      try {
        const [configs, skills] = await Promise.all([
          this.fetchSportConfigs({ active: true }),
          this.fetchCustomerSkills({ customerId: this.$route.params.id }),
        ]);

        this.sportConfigs = Array.isArray(configs) ? configs : [];
        this.customerSkills = Array.isArray(skills) ? skills : [];
        this.skillDrafts = {};

        this.sportConfigs.forEach((config) => {
          const existing = this.customerSkills.find(skill => skill.sport_master === config.sport_master);
          const draft = {
            role_key: existing ? existing.role_key : null,
            skills: {},
            overall: existing ? existing.overall : null,
            last_skills_updated_at: existing ? existing.last_skills_updated_at : null,
          };

          this.activeSkills(config).forEach((skill) => {
            draft.skills[skill.key] = existing && existing.skills && existing.skills[skill.key] !== undefined
                ? existing.skills[skill.key]
                : null;
          });

          this.$set(this.skillDrafts, config.sport_master, draft);
        });

        if (!this.selectedSkillSport || !this.sportConfigs.find(config => config.sport_master === this.selectedSkillSport)) {
          const first = this.sortedSportConfigs[0];
          this.selectedSkillSport = first ? first.sport_master : null;
        }
      } finally {
        this.loadingSkills = false;
      }
    },
    getSkillDraft(sportMaster){
      if (!this.skillDrafts[sportMaster]) {
        this.$set(this.skillDrafts, sportMaster, {
          role_key: null,
          skills: {},
          overall: null,
          last_skills_updated_at: null,
        });
      }
      return this.skillDrafts[sportMaster];
    },
    getSportIcon(sportMaster){
      switch (sportMaster) {
        case 'calcio': return 'mdi-soccer';
        case 'basket': return 'mdi-basketball';
        case 'padel': return 'mdi-tennis';
        case 'tennis': return 'mdi-tennis-ball';
        case 'pallavolo': return 'mdi-volleyball';
        case 'beach_volley': return 'mdi-beach';
        case 'pickleball': return 'mdi-tennis';
        case 'fitness': return 'mdi-dumbbell';
        default: return 'mdi-star-outline';
      }
    },
    getSportLabel(sportMaster){
      switch (sportMaster) {
        case 'calcio': return 'Calcio';
        case 'basket': return 'Basket';
        case 'padel': return 'Padel';
        case 'tennis': return 'Tennis';
        case 'pallavolo': return 'Pallavolo';
        case 'beach_volley': return 'Beach Volley';
        case 'pickleball': return 'Pickleball';
        case 'fitness': return 'Fitness';
        default: return sportMaster;
      }
    },
    getSkillShort(skill){
      const base = (skill && (skill.short_label || skill.key || skill.label || skill.name)) || '';
      return base.toString().substring(0, 3).toUpperCase();
    },
    formatDateTime(value){
      if (!value) return 'Mai aggiornate';
      const date = new Date(value);
      if (isNaN(date.getTime())) return 'Mai aggiornate';
      return date.toLocaleString('it-IT', {
        day: '2-digit',
        month: 'long',
        year: 'numeric',
        hour: '2-digit',
        minute: '2-digit',
      });
    },
    getSkillValue(config, skill){
      const draft = this.getSkillDraft(config.sport_master);
      const value = Number(draft.skills[skill.key]);
      const min = skill.min || 1;
      const max = skill.max || 10;
      if (isNaN(value)) return min;
      return Math.max(min, Math.min(max, value));
    },
    adjustSkill(config, skill, delta){
      const draft = this.getSkillDraft(config.sport_master);
      const min = skill.min || 1;
      const max = skill.max || 10;
      const current = Number(draft.skills[skill.key] || min);
      let next = current + delta;
      if (next < min) next = min;
      if (next > max) next = max;
      this.$set(draft.skills, skill.key, next);
      this.recomputeSkillOverall(config);
    },
    recomputeSkillOverall(config){
      const draft = this.getSkillDraft(config.sport_master);
      let sumWeighted = 0;
      let sumWeights = 0;

      this.activeSkills(config).forEach((skill) => {
        const value = Number(draft.skills[skill.key]);
        if (!isNaN(value)) {
          const weight = skill.weight || 1;
          sumWeighted += value * weight;
          sumWeights += weight;
        }
      });

      draft.overall = sumWeights ? Math.round((sumWeighted / sumWeights) * 10) / 10 : null;
    },
    getRadarGridPoints(factor){
      const center = 100;
      const baseRadius = 70 * (factor || 1);
      const count = this.radarSkills.length || 6;
      const points = [];

      for (let i = 0; i < count; i++) {
        const angle = (Math.PI * 2 / count) * i - Math.PI / 2;
        points.push(`${center + baseRadius * Math.cos(angle)},${center + baseRadius * Math.sin(angle)}`);
      }

      return points.join(' ');
    },
    roleItems(config){
      return Array.isArray(config.roles)
          ? config.roles
              .filter(role => role.active !== false)
              .map(role => ({
                text: role.name || role.label || role.key,
                value: role.key,
                description: role.description || null,
              }))
          : [];
    },
    activeSkills(config){
      return Array.isArray(config.skills)
          ? config.skills.filter(skill => skill.active !== false && skill.key)
          : [];
    },
    async saveSkill(config){
      const draft = this.getSkillDraft(config.sport_master);

      this.savingSkill = true;
      try {
        const result = await this.upsertCustomerSkill({
          customerId: this.$route.params.id,
          sport_master: config.sport_master,
          item: {
            role_key: draft.role_key,
            skills: draft.skills,
          },
        });

        if(result && result.success){
          this.$set(this.skillDrafts, config.sport_master, {
            role_key: result.result.role_key,
            skills: result.result.skills || {},
            overall: result.result.overall,
            last_skills_updated_at: result.result.last_skills_updated_at,
          });
          this.setNotification({
            active: true,
            color: 'success',
            mode: 'multi-line',
            text: this.$t('updateSuccess')
          });
        }else{
          this.setNotification({
            active: true,
            color: 'error',
            mode: 'multi-line',
            text: result && result.message ? result.message : result
          });
        }
      } finally {
        this.savingSkill = false;
      }
    },
    async update(){

      await this.checkItem()
      if(!this.check){
        return
      }else {
        await this.resetError()
      }

      await this.setLoading(true);
      var result = await this.updateItem({...this.$route.params, item:this.item})
      await this.setLoading(false);

      if(result.success){

        this.setNotification({
          active: true,
          color: 'success',
          mode: 'multi-line',
          text: this.$t('updateSuccess')
        })

      }else {

        this.setNotification({
          active: true,
          color: 'error',
          mode: 'multi-line',
          text: result
        })

      }


    },

    async checkItem(){

      this.check = true

      if(!this.item.name){
        this.check = false
        this.errors.name = this.$t('fillMandatory');
      }

      if(!this.item.surname){
        this.check = false
        this.errors.surname = this.$t('fillMandatory');
      }

      if(!this.item.email){
        this.check = false
        this.errors.email = this.$t('fillMandatory');
      }

    },
    setAddressData: function (addressData, placeResultData, id) {

      this.item.position.type = "Point"
      this.item.position.coordinates = [addressData.longitude, addressData.latitude]

      var country = placeResultData.address_components.filter((info) => {
        if(info.types.includes('country')){
          return info
        }
      })

      this.item.financial_info.address = addressData.name
      this.item.financial_info.city = addressData.locality
      this.item.financial_info.province = addressData.administrative_area_level_2
      this.item.financial_info.postal_code = addressData.postal_code
      this.item.financial_info.country = (country[0].short_name) ? country[0].short_name : addressData.country

    },

    async resetError(){
      this.errors = {
        name: '',
        surname: '',
        email: '',
        password: ''
      }
    },

  },
  mounted() {

  },
}
</script>

<style scoped>
.customer-skills-editor {
  border-radius: 12px;
  background: #ffffff;
}

.customer-skills-title {
  font-weight: 700;
  letter-spacing: 0.02em;
}

.customer-skills-sport-bar {
  background: #f5f6fb;
}

.customer-skills-sport-pill {
  border-radius: 999px;
  background: #ffffff !important;
  font-size: 13px;
  font-weight: 600;
  text-transform: none;
}

.customer-skills-sport-pill--active {
  background: linear-gradient(135deg, #1e2a5a, #00a86b) !important;
  color: #ffffff !important;
}

.customer-skills-section-title {
  color: #1e2a5a;
  font-size: 13px;
  font-weight: 800;
  letter-spacing: 0.06em;
  text-transform: uppercase;
}

.customer-skills-role-card,
.customer-skills-skill-card,
.customer-skills-overall-card,
.customer-skills-radar-card {
  border-radius: 12px;
}

.customer-skills-role-card {
  cursor: pointer;
  transition: border-color 0.15s ease, box-shadow 0.15s ease, transform 0.15s ease;
}

.customer-skills-role-card:hover {
  box-shadow: 0 4px 14px rgba(30, 42, 90, 0.12);
  transform: translateY(-1px);
}

.customer-skills-role-card--active {
  border-color: #00a86b;
  background: linear-gradient(135deg, #1e2a5a, #00a86b) !important;
  color: #ffffff !important;
}

.customer-skills-skill-card {
  background: #fafbff;
}

.customer-skills-skill-badge {
  align-items: center;
  background: #1e2a5a;
  border-radius: 10px;
  color: #ffffff;
  display: flex;
  flex: 0 0 42px;
  font-size: 11px;
  font-weight: 800;
  height: 42px;
  justify-content: center;
  width: 42px;
}

.customer-skills-description {
  min-height: 36px;
}

.customer-skills-value {
  flex: 0 0 96px;
  justify-content: flex-end;
}

.customer-skills-value-number {
  color: #1b5e20;
  font-size: 24px;
  font-weight: 800;
  min-width: 32px;
  text-align: center;
}

.customer-skills-overall-card {
  background: #f7f9fc;
}

.customer-skills-overall-card--low {
  background: #fff5f2;
}

.customer-skills-overall-card--mid {
  background: #f5f7fb;
}

.customer-skills-overall-card--high {
  background: #fff9e6;
}

.customer-skills-overall-caption {
  color: #6b7280;
  font-size: 12px;
  font-weight: 700;
  letter-spacing: 0.12em;
  text-transform: uppercase;
}

.customer-skills-overall-value {
  color: #1e2a5a;
  font-size: 54px;
  font-weight: 800;
  line-height: 1;
  margin: 8px 0;
}

.customer-skills-overall-label {
  color: #374151;
  font-size: 12px;
  font-weight: 700;
  letter-spacing: 0.08em;
  text-transform: uppercase;
}

.customer-skills-radar-card {
  background: #0f172a;
  color: #e2e8f0;
}

.customer-skills-radar-wrapper {
  margin: 0 auto;
  max-width: 220px;
  width: 100%;
}

.customer-skills-radar-svg {
  height: auto;
  width: 100%;
}

.customer-skills-radar-grid {
  fill: none;
  stroke: rgba(148, 163, 184, 0.45);
  stroke-width: 1;
}

.customer-skills-radar-data {
  fill: rgba(0, 168, 107, 0.28);
  stroke: #00a86b;
  stroke-width: 2;
}

.customer-skills-radar-dot {
  fill: #facc15;
  stroke: #0f172a;
  stroke-width: 1;
}

.customer-skills-radar-text {
  fill: #e2e8f0;
  font-size: 10px;
  font-weight: 700;
}

@media (max-width: 600px) {
  .customer-skills-value {
    flex-basis: 88px;
  }

  .customer-skills-overall-value {
    font-size: 44px;
  }
}
</style>
